import React, { ComponentProps } from 'react'
import classNames from 'classnames'

import './flex.css'

type FlexProps = {
  children: React.ReactNode
  gap?: number
  flex?: number
  direction?: 'column' | 'row'
  align?: 'start' | 'center' | 'end' | 'stretch'
  justify?: 'start' | 'center' | 'end' | 'space-around' | 'space-between' | 'space-evenly'
  style?: React.CSSProperties
} & ComponentProps<'div'>

export function Flex({ children, gap = 16, direction, align, justify, flex, ...props }: FlexProps) {
  const flexStyles = {
    ...props.style,
    '--flex-gap': `${gap}px`,
    '--flex-direction': direction,
    '--flex-align': align,
    '--flex-justify': justify,
    '--flex-flex': flex,
  } as React.CSSProperties

  return (
    <div className={classNames('flex', props.className)} style={flexStyles}>
      {children}
    </div>
  )
}
